import gql from 'graphql-tag';
import { FRAGMENT_DYNAMIC_ZONES } from 'src/modules/layout/components/dynamicZone/queries';

export const QUERY_BRAND_SPACES_DETAILS = gql`
  query BrandSpacesDetails($slug: String!) {
    stores(where: { slug: $slug }, limit: 1) {
      id
      name
      display_name_en
      display_name_de
      slug
      street
      zip
      city
      lat
      lng
      brandspace_type
      image {
        alternativeText
        url
        formats
      }
      dynamic_content {
        ...dynamicZone
      }
    }
  }
  ${FRAGMENT_DYNAMIC_ZONES}
`;
